import { render } from "./AppSetting.vue?vue&type=template&id=53ee011b&scoped=true"
import script from "./AppSetting.vue?vue&type=script&lang=js"
export * from "./AppSetting.vue?vue&type=script&lang=js"

import "./AppSetting.vue?vue&type=style&index=0&id=53ee011b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53ee011b"]])

export default __exports__